import { type AnalyticsConfig } from '@repo/internal-tools-analytics/src/analyticsAdapter.ts'
import { AnalyticsProvider } from '@repo/internal-tools-analytics/src/AnalyticsProvider.tsx'
import { createAnalyticsAdapterFromEnv } from '@repo/internal-tools-analytics/src/createAnalyticsAdapterFromEnv.ts'
import { DatadogRUM } from '@repo/internal-tools-datadog-rum/src/lib/datadogRum.ts'
import { TooltipProvider } from '@repo/internal-tools-design-system/src/lib/Tooltip/Tooltip.tsx'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import {
  ENV_APP_VERSION,
  ENV_ENABLE_DD_RUM,
  ENV_SEGMENT_WRITE_KEY,
} from './env.ts'
import '../tailwind.config.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
})

const analyticsConfig = {
  writeKey: ENV_SEGMENT_WRITE_KEY,
} satisfies AnalyticsConfig
const analyticsAdapter = createAnalyticsAdapterFromEnv()

if (ENV_ENABLE_DD_RUM === 'true') {
  DatadogRUM.initialize()
}

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AnalyticsProvider
        adapter={analyticsAdapter}
        appId="ccc-main-app"
        appVersion={ENV_APP_VERSION}
        config={analyticsConfig}
      >
        <TooltipProvider delayDuration={300}>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </TooltipProvider>
      </AnalyticsProvider>
    </StrictMode>,
  )
}
